import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { EditorialMarquee } from "@/components/Marquee";
import { Praise } from "@/components/Praise";
import { Gallery } from "@/components/Gallery";
import { MeetLuke } from "@/components/MeetLuke";
import { HowItWorks } from "@/components/HowItWorks";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  const contactRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollToContact = () =>
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="App grain relative min-h-screen bg-black text-white">
      <Toaster theme="dark" position="top-center" richColors />
      <Navbar />
      <main ref={contactRef}>
        <Hero onQuote={scrollToContact} />
        <TrustStrip />
        <Services />
        <EditorialMarquee />
        <Gallery />
        <Manifesto />
        <MeetLuke />
        <HowItWorks />
        <Praise />
        <Booking />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
